<template>
  <div class="box">
    <h3 class="title has-text-grey">
      Actualización de datos {{ estrategia.name }}
    </h3>
    <form @submit.prevent="actualizar">
      <div class="field is-horizontal">
        <!-- Campos horizontales -->
        <div class="field-body">
          <div class="field">
            <!-- Campo departamento -->
            <label class="label">Departamento</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select
                  v-model="departamentoSeleccionado"
                  ref="select_diplomados"
                  required="required"
                >
                  <option
                    v-for="departamento in departamentos"
                    :key="departamento.id"
                    :value="departamento.id"
                  >
                    {{ departamento.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <!-- Campo municipio -->
            <label class="label">Municipio</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select
                  v-model="municipioSeleccionado"
                  ref="select_diplomados"
                  required="required"
                >
                  <option
                    v-for="municipio in municipios"
                    :key="municipio.id"
                    :value="municipio.id"
                  >
                    {{ municipio.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <!-- <i style="color: black" class="fas fa-graduation-cap"></i> -->
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'municipio' in errores">
              <span v-for="error in errores.municipio" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="field">
        <!-- Campo tipo de documento -->
        <label class="label">Tipo de documento:</label>
        <div class="control has-icons-left is-expanded">
          <span class="select is-fullwidth">
            <select
              v-model="tipoDocSeleccionado"
              ref="select_diplomados"
              required="required"
            >
              <option
                v-for="tipo in tiposDocumento"
                :key="tipo.id"
                :value="tipo.id"
              >
                {{ tipo.name }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <!-- <i style="color: black" class="fas fa-graduation-cap"></i> -->
            <i class="fas fa-id-card-alt"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'tipo_documento' in errores">
          <span v-for="error in errores.tipo_documento" :key="error">
            *{{ error }}
          </span>
        </p>
      </div>
      <div class="field is-horizontal">
        <!-- Campos horizontales -->
        <div class="field-body">
          <div class="field">
            <!-- Campo N identidad -->
            <label class="label">Nº documento de identidad</label>
            <div class="control has-icons-left">
              <input
                class="input has-text-right"
                type="number"
                placeholder="Documento de identidad"
                autofocus="true"
                min="1"
                v-model="numeroDoc"
                required="required"
                :disabled="disabled"
              />
              <span class="icon is-left">
                <i class="far fa-id-badge"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'documento' in errores">
              <span v-for="error in errores.documento" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <!-- Campo fecha nacimiento -->
            <label class="label">Fecha de nacimiento</label>
            <div class="control has-icons-left">
              <input
                class="input has-text-right"
                type="date"
                placeholder="Fecha de nacimiento"
                v-model="fechaNacimiento"
                :disabled="disabled"
                required="required"
              />
              <span class="icon is-left">
                <i class="far fa-calendar-alt"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'fecha_nacimiento' in errores">
              <span v-for="error in errores.fecha_nacimiento" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <!-- Campos horizontales -->
        <div class="field-body">
          <div class="field">
            <!-- Campo primer apellido -->
            <label class="label">Primer Apellido</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="primerApellido"
                :disabled="disabled"
                required="required"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'primer_apellido' in errores">
              <span v-for="error in errores.primer_apellido" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <!-- Campo segundo apellido -->
            <label class="label">Segundo Apellido</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="segundoApellido"
                :disabled="disabled"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'segundo_apellido' in errores">
              <span v-for="error in errores.segundo_apellido" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <!-- Campos horizontales -->
        <div class="field-body">
          <div class="field">
            <!-- Campo primer nombre -->
            <label class="label">Primer Nombre</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="primerNombre"
                required="required"
                :disabled="disabled"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'primer_nombre' in errores">
              <span v-for="error in errores.primer_nombre" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <!-- Campo segundo nombre -->
            <label class="label">Segundo Nombre</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="segundoNombre"
                :disabled="disabled"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'segundo_nombre' in errores">
              <span v-for="error in errores.segundo_nombre" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="field">
        <!-- Campo genero -->
        <label class="label">Género:</label>
        <div class="control has-icons-left is-expanded">
          <span class="select is-fullwidth">
            <select
              v-model="generoSeleccionado"
              ref="select_diplomados"
              required="required"
            >
              <option
                v-for="genero in generos"
                :key="genero.id"
                :value="genero.id"
              >
                {{ genero.name }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-venus-mars"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'genero' in errores">
          <span v-for="error in errores.genero" :key="error">*{{ error }}</span>
        </p>
      </div>
      <label class="label">Celular</label>
      <div class="field has-addons">
        <!-- Campo celular -->
        <div class="control has-icons-left">
          <span class="select">
            <select v-model="codigoSeleccionado">
              <option
                v-for="codigo in codigos"
                :key="codigo.pais"
                :value="codigo.code"
              >
                {{ codigo.code }} - {{ codigo.pais }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-globe"></i>
          </span>
        </div>
        <div class="control has-icons-left is-expanded">
          <input
            class="input has-text-right"
            type="number"
            v-model="celular"
            :disabled="disabled"
            required
          />
          <span class="icon is-small is-left">
            <i class="fas fa-phone"></i>
          </span>
          <p class="help is-danger" v-if="'celular' in errores">
            <span v-for="error in errores.celular" :key="error">
              *{{ error }}
            </span>
          </p>
        </div>
      </div>
      <div class="field">
        <!-- Campo email -->
        <label class="label">E-Mail</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="email"
            v-model="email"
            required="required"
            :disabled="disabled"
          />
          <span class="icon is-left">
            <i class="far fa-envelope"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'email' in errores">
          <span v-for="error in errores.email" :key="error">*{{ error }}</span>
        </p>
      </div>

      <hr />
      <div class="field is-horizontal">
        <!-- Campos nuevos1 -->
        <div class="field-body">
          <div class="field">
            <!-- Campo cargo -->
            <label class="label">Cargo:</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select
                  v-model="cargoSeleccionado"
                  ref="select_diplomados"
                  required="required"
                >
                  <option
                    v-for="cargo in cargos"
                    :key="cargo.id"
                    :value="cargo.id"
                  >
                    {{ cargo.name }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-user-graduate"></i>
              </span>
            </div>

            <p class="help is-danger" v-if="'cargo' in errores">
              <span v-for="error in errores.cargo" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <!-- Campo Sede Educativa -->
            <label class="label">Sede Educativa:</label>

            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select
                  v-model="sedeSeleccionada"
                  ref="select_diplomados"
                  required="required"
                  :disabled="consultando"
                >
                  <option v-for="sede in sedes" :key="sede.id" :value="sede.id">
                    {{ sede.ie }} - {{ sede.sede }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-user-graduate"></i>
              </span>
            </div>

            <p class="help is-danger" v-if="'file2' in errores">
              <span v-for="error in errores.file2" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <!-- Campos nuevos2 -->
        <div class="field-body">
          <div class="field">
            <!-- Campo area -->
            <label class="label">Área a la que pertenece</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select v-model="areaPertenece" required="required">
                  <option
                    v-for="area in areas"
                    :key="area.nombre"
                    :value="area.nombre"
                  >
                    {{ area.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-globe"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <!-- Campo tipo vinculacion -->
            <label class="label">Tipo de vinculación:</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select v-model="tipoVinculacion" required="required">
                  <option
                    v-for="vinculacion in vinculaciones"
                    :key="vinculacion.nombre"
                    :value="vinculacion.nombre"
                  >
                    {{ vinculacion.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-user-graduate"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <!-- Campo nivel pertenece -->
            <label class="label">Nivel al que pertenece:</label>

            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select v-model="nivelPertenece" required="required">
                  <option
                    v-for="nivel in niveles"
                    :key="nivel.nombre"
                    :value="nivel.nombre"
                  >
                    {{ nivel.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-user-graduate"></i>
              </span>
            </div>

            <p class="help is-danger" v-if="'file2' in errores">
              <span v-for="error in errores.file2" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <hr />

      <div class="field">
        <!-- Campo Direccion NUEVO -->
        <label class="label">Dirección:</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="text"
            v-model="direccion"
            :disabled="disabled"
          />
          <span class="icon is-left">
            <i class="far fa-home"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'email' in errores">
          <span v-for="error in errores.email" :key="error">*{{ error }}</span>
        </p>
      </div>

      <div class="field is-horizontal">
        <!-- Campos horizontales -->
        <div class="field-body">
          <div class="field">
            <!-- Campo carta nombramiento -->
            <label class="label">Acta de Nombramiento</label>
            <div
              class="file is-medium has-name is-boxed is-expanded is-fullwidth"
              :class="{ 'is-success': file1Name }"
            >
              <label class="file-label">
                <input
                  class="file-input"
                  ref="file1"
                  @change="selectF1"
                  type="file"
                  name="file1"
                  accept="application/pdf"
                  required="required"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                </span>
                <span v-if="file1Name" class="file-name">{{ file1Name }}</span>
                <span v-else class="file-name">Seleccione un archivo...</span>
              </label>
            </div>
            <p class="help is-danger" v-if="'file' in errores">
              <span v-for="error in errores.file" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <!-- Campo carta Doc identidad -->
            <label class="label">Documento de identidad</label>
            <div
              class="file is-medium has-name is-boxed is-expanded is-fullwidth"
              :class="{ 'is-success': file2Name }"
            >
              <label class="file-label">
                <input
                  class="file-input"
                  ref="file2"
                  @change="selectF2"
                  type="file"
                  name="file2"
                  accept="application/pdf"
                  required="required"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                </span>
                <span v-if="file2Name" class="file-name">{{ file2Name }}</span>
                <span v-else class="file-name">Seleccione un archivo...</span>
              </label>
            </div>
            <p class="help is-danger" v-if="'file2' in errores">
              <span v-for="error in errores.file2" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <!-- Campo carta compromiso -->
            <label class="label">Acta de Compromiso</label>
            <div
              class="file is-medium has-name is-boxed is-expanded is-fullwidth"
              :class="{ 'is-success': file3Name }"
            >
              <label class="file-label">
                <input
                  class="file-input"
                  ref="file3"
                  @change="selectF3"
                  type="file"
                  name="file3"
                  accept="application/pdf"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                </span>
                <span v-if="file3Name" class="file-name">{{ file3Name }}</span>
                <span v-else class="file-name">Seleccione un archivo...</span>
              </label>
            </div>
            <p class="help is-danger" v-if="'file3' in errores">
              <span v-for="error in errores.file3" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div>
        <input
          type="checkbox"
          id="checkbox2"
          v-model="checked"
          required="required"
        />
        <!-- Checkbox -->
        <label for="checkbox2">
          He leído y aceptado el tratado y uso de mis datos.
          <a
            href="https://www.computadoresparaeducar.gov.co/publicaciones/66/politicas-y-condiciones-de-uso/"
            target="_blank"
          >
            <b><u>Ver</u></b>
          </a>
        </label>
      </div>
      <hr />
      <div class="field is-grouped is-grouped-right">
        <!-- Boton -->
        <div class="control">
          <button
            type="submit"
            class="button is-block is-info"
            :class="{ 'is-loading': consultando }"
            :disabled="consultando || !checked"
          >
            Actualizar
          </button>
        </div>
      </div>
      <p class="help is-danger" v-if="'otros' in errores">
        *{{ errores.otros }}
      </p>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import {
  actaNombramiento,
  departamentos,
  municipiosDepartamento,
  tiposDocumento,
  generos,
  cargos,
  sedesMunicipio
} from "@/api";
export default {
  data() {
    return {
      codigos: [
        { pais: "Colombia", code: "+57" },
        { pais: "Venezuela", code: "+58" },
        { pais: "Panamá", code: "+507" },
        { pais: "Brasil", code: "+55" },
        { pais: "Perú", code: "+51" },
        { pais: "Ecuador", code: "+593" },
        { pais: "Bolivia", code: "+591" },
        { pais: "Paraguay", code: "+595" },
        { pais: "Uruguay", code: "+598" },
        { pais: "México", code: "+52" },
        { pais: "Costa Rica", code: "+506" },
        { pais: "Cuba", code: "+53" },
        { pais: "Guatemala", code: "+502" },
        { pais: "Honduras", code: "+504" },
        { pais: "Jamaica", code: "+876" },
        { pais: "Nicaragua", code: "+505" },
        { pais: "Puerto Rico", code: "+1787" },
        { pais: "Rep. Dominicana", code: "+809" }
      ],
      areas: [
        { nombre: "Matemáticas" },
        { nombre: "Humanidades (Lengua castellana/Idiomas extranjeros)" },
        { nombre: "Ciencias (Sociales/Historia/Constitución Política)" },
        { nombre: "Ciencias (Naturales/Educación Ambiental)" },
        { nombre: "Tecnología e Informática" },
        { nombre: "Educación artística y cultural" },
        { nombre: "Educación física, recreación y deportes" },
        { nombre: "Otra" }
      ],
      vinculaciones: [{ nombre: "Carrera" }, { nombre: "Provisional" }],
      niveles: [
        { nombre: "Preescolar" },
        { nombre: "Básica Primaria" },
        { nombre: "Básica Secundaria" },
        { nombre: "Media" },
        { nombre: "Superior" }
      ],
      codigoSeleccionado: "+57",
      consultando: false,
      errores: {},
      departamentos: [],
      municipios: [],
      tiposDocumento: [],
      generos: [],
      cargos: [],
      departamentoSeleccionado: null,
      municipioSeleccionado: null,
      tipoDocSeleccionado: null,
      numeroDoc: null,
      fechaNacimiento: null,
      primerApellido: "",
      segundoApellido: "",
      primerNombre: "",
      segundoNombre: "",
      celular: null,
      email: "",
      generoSeleccionado: null,
      cargoSeleccionado: null,
      file1: null,
      file2: null,
      //Se agregan los nuevos campos del modelo
      sedeSeleccionada: "",
      areaPertenece: null,
      tipoVinculacion: null,
      nivelPertenece: null,
      direccion: "",
      file3: null, //Acta de compromiso
      checked: null, //No es necesario, creo
      sedes: [], // 05/08
      cel: false
    };
  },
  computed: {
    ...mapGetters({
      estrategia: "getEstrategia"
    }),
    disabled() {
      return this.consultando;
    },
    file1Name() {
      return this.file1 ? this.file1.name : null;
    },
    file2Name() {
      return this.file2 ? this.file2.name : null;
    },
    file3Name() {
      return this.file3 ? this.file3.name : null;
    }
  },
  methods: {
    checkcel() {
      console.log(this.celular);
      if (this.celular == null) {
        this.cel = false;
        alert("Número de celular inválido.");
      } else {
        if (!(this.celular.length === 10)) {
          this.cel = false;
          alert("Número de celular inválido.");
        } else {
          this.cel = true;
        }
      }
    },

    actualizar() {
      this.checkcel();

      if (this.cel == true) {
        this.errores = {};
        this.consultando = true;
        axios
          .post(actaNombramiento(), this.datos())
          .then(response => {
            console.log(this.datos);
            console.log(response);
            alert("Docente en Revision");
            this.$globalEventBus.$emit("salir");
            // this.$emit('salir');
          })
          .catch(error => {
            console.log("Error");
            // alert("Ocurrio un error");
            console.log(error);
            console.log(error.response);
            switch (error.response.status) {
              case 400:
                this.errores = error.response.data;
                break;
              case 406:
                this.errores.otros = error.response.data.descripcion;
                break;
              default:
                break;
            }
          })
          .then(() => {
            this.consultando = false;
            // alert("Operacion completada");
          });
      }
    },
    datos() {
      var formData = null;
      formData = new FormData();
      formData.append("municipio", this.municipioSeleccionado);
      formData.append("tipo_documento", this.tipoDocSeleccionado);
      formData.append("documento", this.numeroDoc);
      formData.append("fecha_nacimiento", this.fechaNacimiento);
      formData.append("primer_apellido", this.primerApellido);
      formData.append("segundo_apellido", this.segundoApellido);
      formData.append("primer_nombre", this.primerNombre);
      formData.append("segundo_nombre", this.segundoNombre);
      formData.append("genero", this.generoSeleccionado);
      formData.append("celular", this.codigoSeleccionado + this.celular);
      formData.append("email", this.email);
      formData.append("cargo", this.cargoSeleccionado);
      formData.append("file", this.file1);
      formData.append("file2", this.file2);
      formData.append("sede_educativa", this.sedeSeleccionada);
      formData.append("area_pertenence", this.areaPertenece);
      formData.append("tipo_vinculacion", this.tipoVinculacion);
      formData.append("nivel_pertenece", this.nivelPertenece);
      formData.append("direccion", this.direccion);
      formData.append("file3", this.file3);
      formData.append("estrategia", this.estrategia.id);
      return formData;
    },
    fetchTiposDoc() {
      this.consultando = true;
      axios
        .get(tiposDocumento)
        .then(response => {
          // console.log(response);
          this.tiposDocumento = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchDptos() {
      this.consultando = true;
      axios
        .get(departamentos)
        .then(response => {
          // console.log(response);
          this.departamentos = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchMunicipios(id) {
      this.consultando = true;
      axios
        .get(municipiosDepartamento(id))
        .then(response => {
          // console.log(response);
          this.municipios = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchGeneros() {
      this.consultando = true;
      axios
        .get(generos)
        .then(response => {
          // console.log(response);
          this.generos = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchCargos() {
      this.consultando = true;
      axios
        .get(cargos)
        .then(response => {
          // console.log(response);
          this.cargos = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchSedes(municipioId) {
      this.consultando = true;
      axios
        .get(sedesMunicipio(municipioId))
        .then(response => {
          // console.log(response);
          // this.sedes = response.data.results;
          this.sedes = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    selectF1() {
      console.log("Manejador file1");
      this.file1 = this.$refs.file1.files[0];
      console.log(this.file1);
    },
    selectF2() {
      console.log("Manejador file2");
      this.file2 = this.$refs.file2.files[0];
    },
    selectF3() {
      console.log("Manejador file3");
      this.file3 = this.$refs.file3.files[0];
    },
    salir() {
      this.$store.commit("salir");
      this.$router.push({ name: "inicio", replace: true });
    }
  },
  mounted() {
    this.fetchTiposDoc();
    this.fetchDptos();
    this.fetchGeneros();
    this.fetchCargos();
  },
  watch: {
    departamentoSeleccionado: function (val) {
      // this.municipioSeleccionado = null;
      this.fetchMunicipios(val);
    },
    municipioSeleccionado: function (municipioId) {
      // this.municipioSeleccionado = null;
      this.fetchSedes(municipioId);
    }
  }
};
</script>

<style></style>
